import { createFileRoute } from "@tanstack/react-router";
import PromptUseCaseTypesPage from "@/features/prompt-templates/pages/prompt-use-case-types-page";

export const Route = createFileRoute("/_admin/prompt-engine/use-cases")({
  component: PromptUseCaseTypesPage,
});
